export const GEO_API = process.env.REACT_APP_API_GEO_GOUV_URL || '';
export const GEO_API_ADRESSE = process.env.REACT_APP_API_ADRESSE_GOUV_URL || '';
